/**
 * Audit Log Service
 * Handles audit log retrieval and entity history
 */

import axiosInstance, { apiRequest } from '../axiosInstance';
import { AUDIT_LOG_ENDPOINTS, buildQueryString } from '../endpoints';

const auditLogService = {
  /**
   * Get paginated audit logs with filters
   * @param {Object} params - Query params (entityType, entityId, action, userId, organizationId, fromDate, toDate, searchTerm, page, pageSize)
   * @returns {Promise<Object>} PagedResult of AuditLogDto
   */
  getLogs: async (params = {}) => {
    return apiRequest(() =>
      axiosInstance.get(`${AUDIT_LOG_ENDPOINTS.LIST}${buildQueryString(params)}`)
    );
  },

  /**
   * Get a single audit log with full details (field changes)
   * @param {number} id - Audit log ID
   * @returns {Promise<Object>} AuditLogDetailedDto
   */
  getLogById: async (id) => {
    return apiRequest(() =>
      axiosInstance.get(AUDIT_LOG_ENDPOINTS.GET_BY_ID(id))
    );
  },

  /**
   * Get all audit logs for a specific entity
   * @param {string} entityType - Entity type (e.g. 'FormSubmission', 'WorkOrder')
   * @param {number} entityId - Entity ID
   * @returns {Promise<Array>} List of AuditLogDto
   */
  getEntityHistory: async (entityType, entityId) => {
    return apiRequest(() =>
      axiosInstance.get(AUDIT_LOG_ENDPOINTS.ENTITY_HISTORY(entityType, entityId))
    );
  },

  /**
   * Get user activity logs
   * @param {number} userId - User ID
   * @returns {Promise<Object>} PagedResult of AuditLogDto
   */
  getUserActivity: async (userId) => {
    return apiRequest(() =>
      axiosInstance.get(AUDIT_LOG_ENDPOINTS.USER_ACTIVITY(userId))
    );
  },
};

export default auditLogService;
